export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";